<!-- Backdrop -->
@if (showBackdrop && (mode === 'over' || mode === 'push')) {
<div [class]="computedBackdropClasses()" (click)="closeOnBackdrop && close()" [attr.aria-hidden]="true"></div>
}

<!-- Drawer -->
<div #drawerElement [class]="computedDrawerClasses()" [style.transform]="getTransform()"
  [style.visibility]="isInitialized() && isVisible() ? 'visible' : 'hidden'"
  [attr.aria-hidden]="isOpen() ? null : 'true'" [attr.aria-label]="ariaLabel" role="dialog"
  [attr.aria-modal]="isOpen() ? 'true' : null" [attr.inert]="isOpen() ? null : ''"
  [attr.tabindex]="isOpen() ? '0' : '-1'" (keydown)="handleKeyDown($event)">
  <!-- Glass shimmer effect -->
  <div
    class="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-700 pointer-events-none overflow-hidden">
    <div class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/10 to-transparent
                    transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                    transition-transform duration-1500 ease-out"></div>
  </div>

  <!-- Premium floating particles -->
  @if (variant === 'premium') {
  <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
    <div class="absolute top-1/4 left-1/6 w-2 h-2 bg-primary-400/40 rounded-full animate-pulse"></div>
    <div class="absolute bottom-1/3 right-1/4 w-1.5 h-1.5 bg-white/30 rounded-full animate-pulse delay-1000"></div>
    <div class="absolute top-3/4 left-3/4 w-1 h-1 bg-primary-300/50 rounded-full animate-pulse delay-2000"></div>
  </div>
  }

  <!-- Drawer Content -->
  <!-- Make this a column flex with defined height and allow children to shrink (min-h-0)
    so that a flex-1 scroll container can compute remaining space correctly. -->
  <div [class]="computedContentClasses() + ' flex flex-col h-full min-h-0'">
    <!-- Header -->
    @if (hasHeader) {
    <div class="shrink-0 p-6 border-b border-blue-200/10 relative">
      <div class="flex items-center justify-between relative z-10">
        <!-- Custom header content takes priority -->
        <ng-content select="[slot=header]"></ng-content>

        <!-- Fallback to default header if no custom content -->
        @if (!hasCustomHeader) {
        <div>
          @if (title) {
          <h4 class="text-xl font-semibold text-white">
            {{ title }}
          </h4>
          } @if (subtitle) {
          <p class="mt-1 text-sm text-slate-300">
            {{ subtitle }}
          </p>
          }
        </div>
        } @if (showCloseButton) {
        <button type="button" (click)="handleCloseClick($event)" class="relative z-20 inline-flex items-center justify-center rounded-2xl border border-blue-200/18 bg-slate-900/35 p-2 text-slate-300 transition-all duration-200 hover:border-blue-200/28 hover:bg-white/8 hover:text-white
                         focus:ring-2 focus:ring-primary-500/50 focus:outline-none
                         cursor-pointer" [attr.aria-label]="'Close ' + (title || 'drawer')">
          <ui-icon name="x" size="md"></ui-icon>
        </button>
        }
      </div>

      <!-- Header glass accent -->
      <div class="absolute inset-0 bg-linear-to-r from-primary-500/5 to-transparent
                        opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
    </div>
    }

    <!-- Content Area: flexible, allowed to shrink, and scrollable -->
    <div class="flex-1 min-h-0 overflow-x-hidden relative" [class.overflow-y-auto]="scrollContent"
      [class.overflow-y-hidden]="!scrollContent">
      <div class="relative z-10 flex h-full min-h-0 w-full flex-col">
        <ng-content></ng-content>
      </div>
    </div>

    <!-- Footer -->
    @if (hasFooter) {
    <div class="shrink-0 p-6 border-t border-blue-200/10 relative">
      <div class="relative z-10">
        <ng-content select="[slot=footer]"></ng-content>
      </div>

      <!-- Footer glass accent -->
      <div class="absolute inset-0 bg-linear-to-r from-transparent to-primary-500/5
                          opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
    </div>
    }
  </div>

  <!-- Resize handle (for resizable drawers) -->
  @if (resizable) {
  <div class="absolute bg-primary-500/20 hover:bg-primary-500/40 transition-colors duration-200 cursor-col-resize z-20"
    [class]="resizeHandleClasses()" (mousedown)="startResize($event)"></div>
  }

  <!-- Open state glow -->
  @if (isOpen()) {
  <div class="absolute inset-0 opacity-30 pointer-events-none">
    <div class="absolute inset-0 bg-primary-500/5 animate-glass-pulse"></div>
  </div>
  }
</div>
